import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50b08022"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b08022')) {
      api.createRecord('50b08022', component.options)
    } else {
      api.reload('50b08022', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50b08022", function () {
      api.rerender('50b08022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/reportes/preguntas_frecuentes/index.vue"
export default component.exports